var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "device-icon", attrs: { title: _vm.title } },
    [
      _vm.type === "browser"
        ? [
            _vm.isChrome
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#4285F4",
                        d: "M12 0C8.21 0 4.831 1.757 2.632 4.501l3.953 6.848A5.454 5.454 0 0 1 12 6.545h10.691A12 12 0 0 0 12 0z",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#EA4335",
                        d: "M12 0v6.545a5.454 5.454 0 0 1 5.455 5.454h5.454A12 12 0 0 0 12 0z",
                        opacity: ".8",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#FBBC05",
                        d: "M6.545 12A5.454 5.454 0 0 0 12 17.454v5.455A12 12 0 0 1 2.632 4.5l3.953 6.848A5.43 5.43 0 0 0 6.545 12z",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#34A853",
                        d: "M12 17.454A5.454 5.454 0 0 0 17.455 12h5.454A12 12 0 0 1 12 22.909v-5.455z",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#fff", cx: "12", cy: "12", r: "4.364" },
                    }),
                  ]
                )
              : _vm.isFirefox
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#FF7139",
                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#FF7139", cx: "12", cy: "12", r: "6" },
                    }),
                  ]
                )
              : _vm.isSafari
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#006CFF", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#fff",
                        d: "M12 6l1.5 4.5L18 12l-4.5 1.5L12 18l-1.5-4.5L6 12l4.5-1.5z",
                      },
                    }),
                  ]
                )
              : _vm.isEdge
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#0078D7", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("path", { attrs: { fill: "#fff", d: "M8 8h8v8H8z" } }),
                  ]
                )
              : _vm.isPostman
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#FF6C37", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { fill: "#fff", d: "M7 8h4v8H7V8zm6 0h4v3h-4V8z" },
                    }),
                  ]
                )
              : _vm.isInsomnia
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#5849BE", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#fff", cx: "12", cy: "12", r: "4" },
                    }),
                  ]
                )
              : _vm.isAxios
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#5A29E4", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "16",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "10",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("A")]
                    ),
                  ]
                )
              : _vm.isCurl
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#073551", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "7",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("cURL")]
                    ),
                  ]
                )
              : _vm.isDotNet
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#512BD4", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "7",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(".NET")]
                    ),
                  ]
                )
              : _vm.isPython
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#3776AB", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#FFD43B",
                        d: "M12 6c-2 0-3 1-3 2v1h3v1H8v2c0 1 1 2 3 2h2c2 0 3-1 3-2v-4c0-1-1-2-3-2h-1z",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#FFD43B", cx: "10", cy: "8", r: "0.8" },
                    }),
                  ]
                )
              : _vm.isNode
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#339933", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "7",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("JS")]
                    ),
                  ]
                )
              : _vm.isGo
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#00ADD8", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "8",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("Go")]
                    ),
                  ]
                )
              : _vm.isJava
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#007396", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "16",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "10",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("J")]
                    ),
                  ]
                )
              : _vm.isPhp
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#777BB4", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "7",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("PHP")]
                    ),
                  ]
                )
              : _vm.isRuby
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#CC342D", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "7",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("RB")]
                    ),
                  ]
                )
              : _vm.isHttpie
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#73DC8C", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "6",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("HTTP")]
                    ),
                  ]
                )
              : _vm.isWget
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#4E9A06", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: "12",
                          y: "15",
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "6",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v("wget")]
                    ),
                  ]
                )
              : _vm.isBot
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#9E9E9E", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        fill: "#fff",
                        d: "M12 4a2 2 0 0 1 2 2v1h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h1V6a2 2 0 0 1 2-2zm-2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
                      },
                    }),
                  ]
                )
              : _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("circle", {
                      attrs: { fill: "#666", cx: "12", cy: "12", r: "10" },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: { fill: "#fff", cx: "12", cy: "12", r: "6" },
                    }),
                  ]
                ),
          ]
        : _vm.type === "os"
        ? [
            _vm.isWindows
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#00A4EF",
                        d: "M3 12V6.5l7-1v6.5H3zm8-7.5L21 3v9h-10V4.5zM3 13h7v6.5l-7-1V13zm8 0h10v9l-10-1.5V13z",
                      },
                    }),
                  ]
                )
              : _vm.isApple
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#555",
                        d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z",
                      },
                    }),
                  ]
                )
              : _vm.isAndroid
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#3DDC84",
                        d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z",
                      },
                    }),
                  ]
                )
              : _vm.isLinux
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#FCC624",
                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
                      },
                    }),
                  ]
                )
              : _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#666",
                        d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z",
                      },
                    }),
                  ]
                ),
          ]
        : [
            _vm.isMobile
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#666",
                        d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z",
                      },
                    }),
                  ]
                )
              : _vm.isTablet
              ? _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#666",
                        d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z",
                      },
                    }),
                  ]
                )
              : _c(
                  "svg",
                  {
                    attrs: {
                      viewBox: "0 0 24 24",
                      width: _vm.size,
                      height: _vm.size,
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "#666",
                        d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z",
                      },
                    }),
                  ]
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }